var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"pt-custom-card"},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("PM TOOL > DONE TASKS")]),_c('Table',{attrs:{"columns":_vm.tblColumns,"data":_vm.tblData,"height":"200","size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }